<template>
  <div>
    <v-main>
      <v-app-bar color="primary" flat app dark>
        <v-btn style="position: absolute" icon :to="`/`">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-app-bar-title style="min-width: fit-content;">{{ $t('settings.notificationSettings') }}</v-app-bar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-container fluid>
        <v-row align="center">
          <v-col cols="6">
            <div class="d-flex justify-center" v-text="$t('settings.absentContact')"></div>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="absentInput"
              :items="settingList"
              item-title="text"
              item-value="value"
              @update:model-value="changeAbsent"
              variant="underlined"
              color="primary"
            ></v-select>
          </v-col>

          <v-col cols="6">
            <div class="d-flex justify-center" v-text="$t('settings.pickupChange')"></div>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="pickupInput"
              :items="settingList"
              item-title="text"
              item-value="value"
              @update:model-value="changePickup"
              variant="underlined"
              color="primary"
            ></v-select>
          </v-col>

          <v-col cols="6">
            <div class="d-flex justify-center" v-text="$t('settings.chat')"></div>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="chatInput"
              :items="settingList"
              item-title="text"
              item-value="value"
              @update:model-value="changeChat"
              variant="underlined"
              color="primary"
            ></v-select>
          </v-col>

          <v-col cols="6">
            <div class="d-flex justify-center" v-text="$t('settings.newApplication')"></div>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="workflowCreateInput"
              :items="settingList"
              item-title="text"
              item-value="value"
              @update:model-value="changeWorkflowCreate"
              variant="underlined"
              color="primary"
            ></v-select>
          </v-col>

          <v-col cols="6">
            <div class="d-flex justify-center" v-text="$t('settings.applicationApproval')"></div>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="workflowApprovedInput"
              :items="settingList"
              item-title="text"
              item-value="value"
              @update:model-value="changeWorkflowApproved"
              variant="underlined"
              color="primary"
            ></v-select>
          </v-col>

          <v-col cols="6">
            <div class="d-flex justify-center" v-text="$t('settings.applicationRejection')"></div>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="workflowRejectedInput"
              :items="settingList"
              item-title="text"
              item-value="value"
              @update:model-value="changeWorkflowRejected"
              variant="underlined"
              color="primary"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
      <v-snackbar v-model="snackbar" :timeout="timeout" outlined top color="primary">
        {{ snackBarText }}

        <!-- <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
            ×
          </v-btn>
        </template> -->
        <template v-slot:actions>
        <v-btn
          color="outlined"
          variant="text"
          @click="snackbar = false"
        >
          ×
        </v-btn>
      </template>
      </v-snackbar>
    </v-main>
  </div>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";
import { i18n } from '@/plugins/i18n';

import { PostMeRequest } from '@/model/Request';
import { meModule } from '@/store/dataModules/meModule';
import { auth0Module } from '@/store/dataModules/auth0Module';
import LocalDataService from '@/service/LocalDataService';
import { MeNurserySchoolResponse } from 'chaild-api/lib';

interface DataType {
  postMeRequest: PostMeRequest;
}

export default defineComponent({
  data: () => ({
    absentInput: NaN,
    pickupInput: NaN,
    chatInput: NaN,
    workflowCreateInput: NaN,
    workflowApprovedInput: NaN,
    workflowRejectedInput: NaN,
    btnLoading: false,
    selectNursery: NaN,
    timeout: 2000,
    snackBarText: '',
    snackbar: false,
    settingList: [] as Array<{ value: number; text: string }>,
  }),
  computed: {
    nurserySchool(): MeNurserySchoolResponse | null {
      const user = LocalDataService.getUser();
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        return nurserySchool;
      }
      return null;
    },
    nurserySchools(): MeNurserySchoolResponse[] {
      const user = LocalDataService.getUser();
      if (user) {
        const nurserySchools = user.nurserySchools;
        return nurserySchools;
      }
      return [];
    },
  },

  methods: {
    async changeAbsent() {
      if (this.absentInput > -1 && this.nurserySchool) {
        try {
          await meModule.putMe({
            notifications: [
              {
                nurseryId: this.nurserySchool.nurseryId,
                key: 'absentReported',
                value: this.absentInput,
              },
            ],
          });
        } catch {
        } finally {
        }
      }
    },
    async changePickup() {
      if (this.pickupInput > -1 && this.nurserySchool) {
        try {
          await meModule.putMe({
            notifications: [
              {
                nurseryId: this.nurserySchool.nurseryId,
                key: 'pickupReported',
                value: this.pickupInput,
              },
            ],
          });
        } catch {
        } finally {
        }
      }
    },
    async changeChat() {
      if (this.chatInput > -1 && this.nurserySchool) {
        try {
          await meModule.putMe({
            notifications: [
              {
                nurseryId: this.nurserySchool.nurseryId,
                key: 'chatReceived',
                value: this.chatInput,
              },
            ],
          });
        } catch {
        } finally {
        }
      }
    },
    async changeWorkflowCreate() {
      if (this.workflowCreateInput > -1 && this.nurserySchool) {
        try {
          await meModule.putMe({
            notifications: [
              {
                nurseryId: this.nurserySchool.nurseryId,
                key: 'workflowCreated',
                value: this.workflowCreateInput,
              },
            ],
          });
        } catch {
        } finally {
        }
      }
    },
    async changeWorkflowApproved() {
      if (this.workflowApprovedInput > -1 && this.nurserySchool) {
        try {
          await meModule.putMe({
            notifications: [
              {
                nurseryId: this.nurserySchool.nurseryId,
                key: 'workflowApproved',
                value: this.workflowApprovedInput,
              },
            ],
          });
        } catch {
        } finally {
        }
      }
    },
    async changeWorkflowRejected() {
      if (this.workflowRejectedInput > -1 && this.nurserySchool) {
        try {
          await meModule.putMe({
            notifications: [
              {
                nurseryId: this.nurserySchool.nurseryId,
                key: 'workflowRejected',
                value: this.workflowRejectedInput,
              },
            ],
          });
        } catch {
        } finally {
        }
      }
    },
  },

  mounted() {
    this.settingList = [
      { value: 0, text: i18n.global.t('settings.both') },
      { value: 1, text: i18n.global.t('settings.pushOnly') },
      { value: 2, text: i18n.global.t('settings.emailOnly') },
      { value: 3, text: i18n.global.t('settings.noNotification') },
    ];
    
    if (this.nurserySchool) {
      this.absentInput = this.nurserySchool.notifications.absentReported;
      this.pickupInput = this.nurserySchool.notifications.pickupReported;
      this.chatInput = this.nurserySchool.notifications.chatReceived;
      this.workflowCreateInput = this.nurserySchool.notifications.workflowCreated;
      this.workflowApprovedInput = this.nurserySchool.notifications.workflowApproved;
      this.workflowRejectedInput = this.nurserySchool.notifications.workflowRejected;
    }
  },
  beforeUnmount() {
    meModule.setTabIndex('setting')
  },
});
</script>
<style lang="scss" scoped></style>
